<div class="container" #tab cdkDragLockAxis="y" cdkDrag>
    <button class="support-tab" (click)="openSupport()"><mat-icon fontSet="material-icons-outlined">help</mat-icon><span>Support</span></button>
</div>

<ng-template #dialog>
    <div class="dialogComponent">
        <header><b>Support</b><button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button></header>
        <mat-dialog-content>
            <app-panel [no-padding]="true">
                <div class="box-container">
                    <div class="box-body">
                        <h2>Support för ditt företag</h2>
                        <p>I Basetoolsupporten hittar du mängder med artiklar som kan vara till hjälp när du arbetar med Basetool.</p>
                    </div>
                    <div class="box-image">
                        <img src="/assets/images/pages/support/hat_books.png" alt="">
                    </div>
                </div>
                <div class="box-footer">
                    <a class="box-action" href="https://support.basetool.com/sv/foeretag/" mat-flat-button color="primary" target="_blank">Till Basetool Support</a>
                </div>
            </app-panel>

            <app-panel [no-padding]="true">
                <div class="box-container">
                    <div class="box-body">
                        <h2>Låt support hjälpa dig</h2>
                        <p *ngIf="rightsVisible">Genom att ge supporten rättigheter till ditt konto, kan de enklare hjälpa till.</p>
                        <p *ngIf="!rightsVisible">Gå in på ett företag eller konto, för att ge supporten rättigheter.</p>
                    </div>
                    <div class="box-image">
                        <img class="box-image__working" src="/assets/images/pages/support/working.png" alt="">
                    </div>
                </div>
                <div class="box-footer">
                    <button class="box-action" mat-flat-button color="primary" [disabled]="!rightsVisible || addingSupport" (click)="addSupport()">Ge supporten rättigheter</button>
                </div>
            </app-panel>            
        </mat-dialog-content>
    </div>    
</ng-template>